var _path, _path2, _path3, _path4, _polygon, _path5, _path6, _polygon2, _polygon3, _polygon4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-15"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-15",
    cx: 250,
    cy: 350,
    rx: 219.33,
    ry: 127.74,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-15"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-15",
    cx: 373.67,
    cy: 367.84,
    rx: 63.72,
    ry: 36.79,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-15",
    cx: 250,
    cy: 375.19,
    rx: 71.96,
    ry: 41.54,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-15",
    cx: 124.17,
    cy: 367.84,
    rx: 63.72,
    ry: 36.79,
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.8,319.26c.77-8.78-4-27.53-12.1-39.74S65,257.72,54.51,260.31c-9.77,2.41-9.83,14.94.94,24.19s27.17,21.12,31,35.82l9.08,18.41Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8,319.26c.77-8.78-4-27.53-12.1-39.74S65,257.72,54.51,260.31c-9.77,2.41-9.83,14.94.94,24.19s27.17,21.12,31,35.82l9.08,18.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.39,331.34a.65.65,0,0,1-.53-.57c-3.25-30.5-25.36-57-39.41-63.66a.64.64,0,0,1-.3-.86A.62.62,0,0,1,59,266c14.32,6.78,36.84,33.72,40.14,64.69a.63.63,0,0,1-.57.7A.54.54,0,0,1,98.39,331.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.24,350.14c-1-5.06-6.3-13.74-15.46-21.33-10.14-8.39-23.49-13-26.13-19.08-3.17-7.3,3.28-13.36,14.24-11S94,317.9,95.13,340.94Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.84,345.15a.66.66,0,0,1-.52-.48c-6.94-26.49-25.75-37.23-34.72-39.2a.65.65,0,1,1,.28-1.26c9.92,2.18,28.6,13.09,35.69,40.14a.66.66,0,0,1-.73.8Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.8,331.06c-.81-9.23,4.49-38.93,13-51.75s23.93-25.77,34.95-23.05c10.26,2.54,10.33,15.7-1,25.42s-28.54,22.2-32.54,37.63l-10,26.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.8,331.06c-.81-9.23,4.49-38.93,13-51.75s23.93-25.77,34.95-23.05c10.26,2.54,10.33,15.7-1,25.42s-28.54,22.2-32.54,37.63l-10,26.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.66,330.9a.69.69,0,0,0,.56-.6c3.41-32.05,26.65-59.89,41.4-66.89a.67.67,0,0,0,.32-.9.66.66,0,0,0-.9-.32c-15,7.13-38.71,35.43-42.17,68a.67.67,0,0,0,.6.74A.61.61,0,0,0,393.66,330.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.13,350.65c1-5.32,5.3-14.35,14.31-23,11-10.61,28.63-15.79,31.41-22.17,3.33-7.66-2.94-13.38-14.36-10.46-15.34,3.92-33.23,21.78-34.4,46Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.39,345.4a.68.68,0,0,0,.55-.49c7.29-27.84,30.89-41.71,40.32-43.78a.68.68,0,0,0,.52-.81.67.67,0,0,0-.81-.52c-10.43,2.3-33.9,16.35-41.34,44.76a.67.67,0,0,0,.48.83A.67.67,0,0,0,397.39,345.4Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.1,151.05c-6.17-6.36-16.42-21.19-16.42-21.19L381.36,108c-.15.06,3.22.07,4.24,0,6.83.46,8.84,1,13.09,5.69,3.37,3.69,15.84,23.08,20.32,29l12.26-16.94c2.84-4.3,2.38-9.11,3.86-12.63s3.86-5.06,5.77-8.23,2.37-5.25,3.94-3.63-.24,6-.48,7-2.62,4,1.37,2.42,10.17-8.86,11.77-10.35,2.43.82,2.07,2.65,1.36,6,.73,9c-.66,3.21-1.13,4.68-4.22,7.79-2.89,2.91-9.94,6.47-12.7,10.28s-8.65,15.65-12.25,22.79c-4.58,9.07-9.6,14.23-15.52,9.16C411.07,158.05,406.39,153.41,404.1,151.05Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.32,107.83c5.23.48,8,1.67,13.22,8.51s17.34,24.85,17.34,24.85l10.47-12.81s7.21,5.49,11,11.91c0,0-10.13,17-14.19,21.29s-7.2,4.63-12.72,0S392,139.39,392,139.39Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.88,141.19c-2.37,3.43-3.9,9-3.48,11.81,0,0-3.3-3.8,2.25-13.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.18 362.9 354.07 362.9 356.44 341.85 342.18 341.85 342.18 362.9",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.46 341.25 394.13 341.67 393.9 319.88 379.57 319.6 381.46 341.25",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.31,193.7c-.23,11.54-2.68,87.91-2.68,87.91a172.29,172.29,0,0,0-1.51,18.82c-.32,15.26,2.88,51.48,2.88,51.48.71,3.29,13,4.63,14.63,1.66,0,0,6.72-52.54,8.63-67.64,1.66-13.18,7.15-56.28,7.15-56.28L375.65,272A131.12,131.12,0,0,0,376,286.8c.49,7,4,48.19,4,48.19.06,2.57,12.84,4.69,15,.91,0,0,4-60.16,4.17-66.57.14-7.31-.88-76.46-.88-76.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.75,356.85l.2-1.79c.66,0,.95.74,1.22,2.32a34.12,34.12,0,0,0,3.15,9.69c2,4.15,3.2,5.88,7.18,10.88.94,1.19,3.07,3.08,3.82,4.4s1,5-.26,5.85c-4.64,3.09-11.69,3.18-16.68,1.72a9.57,9.57,0,0,1-7.24-8.14c-.81-4.54-1.24-7.35-3.55-10.78-.85-1.26-2.22-2.28-2.79-3.68-1-2.53-.21-5.37.45-7.89.57-2.17,1.19-4.56,1.93-4.36v1.34c.89,1,4,2,6.8,2.08C350.78,358.56,354.77,358.23,354.75,356.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.09,338.23c.31.21,1,1,2.31,2.22a45.12,45.12,0,0,0,4.1,3.17,75.8,75.8,0,0,0,9.12,5.73c3.77,2.07,7.17,3.33,11.68,5.36a3.71,3.71,0,0,1,1.26.84,2.56,2.56,0,0,1,.55,1.12,4.66,4.66,0,0,1-1.89,4.5,12.37,12.37,0,0,1-4.71,2,24.32,24.32,0,0,1-11.74.35,33.33,33.33,0,0,1-9.44-4.36,21,21,0,0,0-8.07-3.47c-2.53-.36-5.64-.24-7.84-1.75-2.43-1.68-1.46-5.27-.77-8.36.75-3.36.92-8.5,2.45-8.39l.12,1.35c.14,1.45,3.66,2.12,6.38,2.12,2.26,0,6.53-.59,6.51-1.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.71,213.49a38.69,38.69,0,0,0,13-8.34s-2.07,6-10.56,11l.56,52.7-4.28-39.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.47,106.54c-2.15.51-9,2.36-14.56,4.32a15.48,15.48,0,0,0-7,5.36c-4,5.89-.4,19,2.57,43.64-.22,15.92-.68,35.72-.68,35.72,7.32,5.33,41.47,8.95,56.88-2.3,0,0,.51-59.75-.51-67.52-2-14.88-7.77-18.85-19.79-19.55Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.47,106.54c-2.15.51-9,2.36-14.56,4.32a15.48,15.48,0,0,0-7,5.36c-4,5.89-.4,19,2.57,43.64-.22,15.92-.68,35.72-.68,35.72,7.32,5.33,41.47,8.95,56.88-2.3,0,0,.51-59.75-.51-67.52-2-14.88-7.77-18.85-19.79-19.55Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.46,124c1.08,3.72,7.47,29.86,6.57,39.06a56.92,56.92,0,0,1-3.8,13.74c-2.77,6.55-4.62.69-6.16-3.18a48.79,48.79,0,0,1-2.6-11.17c-.51-4.94,1.48-19.95.71-37.55A3.79,3.79,0,0,1,382.46,124Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.46,124c1.08,3.72,7.47,29.86,6.57,39.06a56.92,56.92,0,0,1-3.8,13.74c-2.77,6.55-4.62.69-6.16-3.18a48.79,48.79,0,0,1-2.6-11.17c-.51-4.94,1.48-19.95.71-37.55A3.79,3.79,0,0,1,382.46,124Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.7,115.6c2.53,2.16-.24,8.39-.24,8.39a7.2,7.2,0,0,0-5.28.9s-5-2.15-5.05-5.89c0-3.4,3.61-2.31,6.18-2.76C381,115.77,382.4,113.78,382.7,115.6Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.7,115.6c2.53,2.16-.24,8.39-.24,8.39a7.2,7.2,0,0,0-5.28.9s-5-2.15-5.05-5.89c0-3.4,3.61-2.31,6.18-2.76C381,115.77,382.4,113.78,382.7,115.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.46,124c-.41-1.46-2.4-1.32-4-1.82a4.28,4.28,0,0,1-2.13-1.84c-.82-1.41,0-3.75,1.14-4h0c-2.45.17-5.36-.39-5.35,2.66,0,3.74,5.05,5.89,5.05,5.89A7.2,7.2,0,0,1,382.46,124Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.07,72A15.56,15.56,0,1,0,380.26,56,15.56,15.56,0,0,0,365.07,72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,83.3s2.81,11.78,3.86,13.7A5.35,5.35,0,0,0,361,99.43l-.37-8.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.76,66.25A5.83,5.83,0,0,0,352,68.07c-2,2.17-.71,8.78,2,15.23l4.76.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.19,83.7c-.94.59-2.34-1.21-3.55-2.41s-5.07-2.78-6.89,1.29,1.92,9.49,5,10.37c5.24,1.51,5.94-1.85,5.94-1.85l.89,21.24h0c3.71,4.53,12.44,4.78,16.77,3.9,3.46-.7,3.51-3.15.1-6.91l-.16-6.09a32.66,32.66,0,0,0,7,.2c3.81-.69,6.16-3.76,7.21-7.93,1.6-6.37,2-13.48.39-25.12-2-14.31-18.75-14-27.62-8.17S360.19,83.7,360.19,83.7Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.23,85.3c-.48,0-2.38-3-3.59-4-1.67-1.45.12-15,.12-15a6.57,6.57,0,0,1,1-7.33c2.19-2.53,5.25-5.63,15.49-4.67,7.3.69,15.28,2.77,21.6-.53a10.9,10.9,0,0,1-3.51,11.67s-2.29,1.55-8.36,2.43-15.59.23-16.89.09c-1.77-.2-2.11,1.52-2.95,6.22C362.36,78.26,361.84,85.23,360.23,85.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.8,67.31l-5.84-3a3.17,3.17,0,0,1,4.33-1.54A3.44,3.44,0,0,1,356.8,67.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.25,103.24s-8.58-1.51-11.6-3a9.8,9.8,0,0,1-4.22-4,13.46,13.46,0,0,0,2.46,4.76c2.25,2.74,13.42,4.7,13.42,4.7Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.38,81.61a1.71,1.71,0,1,1-1.62-1.87A1.75,1.75,0,0,1,375.38,81.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.27,75.17,370.51,77a2.19,2.19,0,0,1,1-2.87A2,2,0,0,1,374.27,75.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.36,93.13l5.34,1.46a2.72,2.72,0,0,1-3.34,2A2.91,2.91,0,0,1,376.36,93.13Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,76.76l-4-1.37A2,2,0,0,1,390.6,74,2.21,2.21,0,0,1,392,76.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,81.13a1.74,1.74,0,0,1-1.54,1.92,1.76,1.76,0,0,1-1.87-1.62,1.71,1.71,0,1,1,3.41-.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.77 80.16 381.39 90.45 386.75 88.59 380.77 80.16",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.31,116.24c-4.75-1-16-5.39-17.06-10.88l-.14-3c-1.85,0-2.69,2.05-3.6,5-.38,7.76,7.81,14.85,16,16.76a14.37,14.37,0,0,1,1.81-5.1A7,7,0,0,1,378.31,116.24Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.27,104a8,8,0,0,1,3.32,2c6.15,6.37,2.64,14.72,2.64,14.72a6.12,6.12,0,0,0-2.24-3.49,5.86,5.86,0,0,0-3.68-1c1.51-1.61.92-4.42.1-6.91Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.15,76.48l-.83-.08a27.52,27.52,0,0,0-8.34.26c-2.68.73-3.65,1.54-5.12,1.56s-2.54-.81-5.34-1.53a31.27,31.27,0,0,0-8.89-.21l-.9.1L354,80a5,5,0,0,1,2.86,1.51L366.14,79c.13.18.26.34.35.45a1.81,1.81,0,0,1,.27.62,23.27,23.27,0,0,0,.93,4.24,5,5,0,0,0,1.08,1.52,4.09,4.09,0,0,0,.56.45l.33.2a5.55,5.55,0,0,0,1,.42l.17.05.26.07.28.06a7.2,7.2,0,0,0,.88.12l.37,0h.47c3.66,0,5.24-1.56,6.21-3.17s.82-3.88,2.5-3.88h.16l.15,0c1.24.25,1,2.34,1.74,3.83A5.73,5.73,0,0,0,385,85.67l.27.25.15.12.16.12.14.09.15.1.12.07.09,0a5.4,5.4,0,0,0,1.44.52l.13,0a8.62,8.62,0,0,0,1.77.16c3.42,0,4.67-1.83,5.27-3a25,25,0,0,0,1.2-4.25,1.3,1.3,0,0,1,.34-.56,3,3,0,0,0,.83-1.56A1.26,1.26,0,0,0,396.15,76.48Zm-17.76,6.06A4.83,4.83,0,0,1,377,84.78h0a5.65,5.65,0,0,1-4,1.29,4.46,4.46,0,0,1-3.77-1.62l-.12-.16a1.4,1.4,0,0,1-.1-.16.6.6,0,0,1-.09-.15l-.08-.13-.05-.11s0-.07-.05-.1-.05-.1-.07-.16h0c-.07-.16-.12-.32-.17-.47h0c0-.1-.06-.19-.08-.28s-.08-.32-.11-.46,0-.05,0-.08l0-.09c-.24-1.12-.49-3.32.16-3.82s2.33-1,5-.8l.29,0a10.15,10.15,0,0,1,1.23.19l.48.1a12.17,12.17,0,0,1,1.2.35l.36.14.4.17.08,0,.14.08a2.33,2.33,0,0,1,.79.58C379,79.83,378.74,81.29,378.39,82.54ZM394.28,82a5.08,5.08,0,0,1-2.71,3.61,5.21,5.21,0,0,1-2,.4,4.47,4.47,0,0,1-4-1.67v0a.61.61,0,0,1-.07-.1.83.83,0,0,1-.08-.12l0-.06-.1-.18-.1-.21a1,1,0,0,1,0-.1l0,0,0-.09a.14.14,0,0,1,0-.07,4,4,0,0,1-.23-.83c-.24-1.25-.33-2.71.21-3.4s2.57-1.45,4.51-1.67c.45,0,.87-.08,1.25-.09h1.11l.33,0a5.61,5.61,0,0,1,.63.09l.14,0h0l.1,0,.15,0,.18.05.29.11,0,0a2.45,2.45,0,0,1,.66.37C395,78.68,394.58,80.89,394.28,82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.27,105.69s3.62,18.17,5.18,30.46,1.27,47,.43,69c-.6,16-3,45.68-3,45.68s-4,.8-13.51-.78c-8.14-1.34-12.26-3.75-14-4.8,0,0,1.51-45.07,2.66-60.81,1.05-14.51,1-22.49,1-22.49l-3.42-33.13s.26-20.82,6.72-21.7C350,106.21,361.27,105.69,361.27,105.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.09,135.49c0-.76-.08-2.4-.21-4.48-.64-10.15.29-24.84,3.71-25.57l.31,1.4c-2.51.54-2.9,19.15-2.59,24.08.14,2.12.24,3.79.21,4.63Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.1,213.87c-1.65-2.81-1.74-4.91-4.23-7.42a8.45,8.45,0,0,1-2.25-3.75c-.76-2.25-.72-4.6-.9-7.06l-14.45.67a91.33,91.33,0,0,0,1.78,16c2.74,12.07,5.39,17.15,10.58,18.32,8.28,1.87,10.32-1.7,7.41-7.67a29.88,29.88,0,0,1-2.66-7.88,14.83,14.83,0,0,0,3.09,2.75,2.9,2.9,0,0,0,3.93-.43C344.76,216.87,343.4,216.08,342.1,213.87Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,107.12s-7.69-.11-12,3.77-6.6,14.26-9.39,24.67-5.27,20.51-6,27.75c-.62,6,1.4,37.86,1.4,37.86s8.79,1.85,15.55-1.86l.29-35.35L347,128.52A33.26,33.26,0,0,0,346,107.12Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,99.77c-1-.21-1.93.32-2.75,1.72s-2.63,4.34-2.63,4.34-.93,9.76,0,12.19c.81,2.1,6.18,12,6.18,12s-.35,9.64-.44,12.52,5.49,14.9,6.12,20.48c0,0,.28-22.69-.55-29-1.44-11-3.24-24.1-5.67-28.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,169.16h-.12l0-1a6.36,6.36,0,0,0,3.28-1.22,12.47,12.47,0,0,1-2.73-2.47c-1.61-2.09-5.14-17-4.06-20.47.92-2.91,3.78-9.33,6.32-9.44h.07c2.54,0,5.89,6.07,7,8.87,1.38,3.37-.87,18.52-2.3,20.74a12.27,12.27,0,0,1-2.51,2.69,6.23,6.23,0,0,0,3.37.94l.13,1a7.74,7.74,0,0,1-4.38-1.28A8,8,0,0,1,353,169.16Zm2.81-33.61h0c-1.5.06-4.18,4.83-5.41,8.73-1,3.19,2.4,17.62,3.89,19.55a12,12,0,0,0,2.82,2.47,11.77,11.77,0,0,0,2.61-2.7c1.32-2.05,3.48-16.71,2.21-19.81C360.39,140,357.35,135.55,355.84,135.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,168.23a1.46,1.46,0,0,1-1.4,1.53,1.47,1.47,0,1,1-.13-2.94A1.47,1.47,0,0,1,363,168.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.4,168.59a1.47,1.47,0,0,1-1.41,1.53,1.46,1.46,0,0,1-1.53-1.4,1.47,1.47,0,1,1,2.94-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.11,150l-.84-.06a.33.33,0,0,1-.31-.35c.17-2.8.08-4.86-.26-5.68-1.48-3.62-4.55-8.15-5.88-8.09s-4,4.83-5.18,8.56a16.75,16.75,0,0,0,.22,5.68.33.33,0,0,1-.27.38l-.84.13a.33.33,0,0,1-.37-.29c-.46-3.11-.52-5.25-.17-6.35.62-2,3.57-9.49,6.54-9.62s6.55,7.09,7.34,9c.44,1.07.57,3.2.37,6.34A.33.33,0,0,1,363.11,150Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.25,103.24c1.32.12,2.47,2.07,5.51,3,5.68,1.68,10.84,4.26,12.43,7.75,2.64,5.78,3.07,6.92,4,32.66s1.26,99,1.26,99a19.8,19.8,0,0,1-8.69,1.75s.23-80.9-.31-99.09-3.3-27.07-7.24-33.07c-1.11-5-4.65-8.34-7-10.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.23,115.26c3.94,6,6.69,14.87,7.24,33.07.06,2.16.12,5.2.17,8.85h0s3.24-16.48,2.67-20-4.37-10.76-4.37-10.76c.49-6-.91-12.86-3.22-17a11.5,11.5,0,0,0-2-2.62,17.27,17.27,0,0,0-2.45-1.66,10.84,10.84,0,0,0-5-1.93l0,1.24C380.58,106.92,384.12,110.24,385.23,115.26Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.24,107c7.55-.12,11.61,3.27,17.15,12,4.73,7.42,15.68,25.19,18.76,30.54,3.48,6,4,8.5,1.24,13-2.59,4.3-27.15,32.66-27.15,32.66l-6.33-11.24,15.78-26.38-18.5-27.33Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.75,106.63c5.46-.29,8.86.84,12.15,4s20.24,31.62,20.24,31.62-2.44,5.83-16.74,13.45l-14-19Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.75,106.63c5.46-.29,8.86.84,12.15,4s20.24,31.62,20.24,31.62-2.44,5.83-16.74,13.45l-14-19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,367.87c.26,0,.66,2.94-.78,4.18-1.67,1.44-6.57,3.81-13.05,3s-10-2.84-12.57-5-6.23-5.23-9.16-5.88c-2.72-.6-5.67-1.83-6.54-2.67s-.75-4.58-.75-4.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,342.49a1,1,0,0,0-1,.87c-.2,1-.41,4-.84,5.72a30,30,0,0,0-.64,9.09c.36,1.91,4.79,3.24,7.63,4.32a36.48,36.48,0,0,1,9.18,5.8c3,2.51,9.45,5.12,13.67,5.09,5,0,10.61-1.65,11.9-4,1.6-2.87.35-4.53-7.06-8-1.4-.65-6.32-3.57-8-4.62-4.54-2.86-9-6.84-11.13-11.9a2.8,2.8,0,0,0-1.06-1.54,2.35,2.35,0,0,0-1.44-.13,12.31,12.31,0,0,0-3.56,1.07c-1,.48-2.41,1-2.39,2.3a4.45,4.45,0,0,0,.28,1.29c.09.26.16.61-.07.76s-.5,0-.69-.19a20,20,0,0,1-2-2.4,7.32,7.32,0,0,0-1.17-1.19,13.78,13.78,0,0,1-1.27-.82C262.89,343.64,263,343.08,263,342.49Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,342.49a1,1,0,0,0-1,.87c-.2,1-.41,4-.84,5.72a30,30,0,0,0-.64,9.09c.36,1.91,4.79,3.24,7.63,4.32a36.48,36.48,0,0,1,9.18,5.8c3,2.51,9.45,5.12,13.67,5.09,5,0,10.61-1.65,11.9-4,1.6-2.87.35-4.53-7.06-8-1.4-.65-6.32-3.57-8-4.62-4.54-2.86-9-6.84-11.13-11.9a2.8,2.8,0,0,0-1.06-1.54,2.35,2.35,0,0,0-1.44-.13,12.31,12.31,0,0,0-3.56,1.07c-1,.48-2.41,1-2.39,2.3a4.45,4.45,0,0,0,.28,1.29c.09.26.16.61-.07.76s-.5,0-.69-.19a20,20,0,0,1-2-2.4,7.32,7.32,0,0,0-1.17-1.19,13.78,13.78,0,0,1-1.27-.82C262.89,343.64,263,343.08,263,342.49Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.33,368.29c-1.29-1.06-2.66-2.09-4-3h0s8.71,5.3,12.23,2.89c2.27-1.54,1.19-3.43,1.13-4s5.54-3.17,7.74-3.43h0c.62.34,1.13.61,1.45.76,7.41,3.43,8.66,5.09,7.06,8-1.29,2.31-5.36,4.12-11.81,4.12C286.86,373.54,280.37,370.8,277.33,368.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.33,368.29c-1.29-1.06-2.66-2.09-4-3h0s8.71,5.3,12.23,2.89c2.27-1.54,1.19-3.43,1.13-4s5.54-3.17,7.74-3.43h0c.62.34,1.13.61,1.45.76,7.41,3.43,8.66,5.09,7.06,8-1.29,2.31-5.36,4.12-11.81,4.12C286.86,373.54,280.37,370.8,277.33,368.29Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,362.38c4.61,1.84,2.64,2.7,1.36,2.89s-9-4.35-13.77-8.09c-4.93-3.9-8-8.16-9.87-9.59-.68-.54-1.42-1.19-2.07-1.81.12-1,.22-1.93.31-2.42a1,1,0,0,1,1-.87c0,.59-.09,1.15.36,1.6a13.78,13.78,0,0,0,1.27.82,7.32,7.32,0,0,1,1.17,1.19,20,20,0,0,0,2,2.4C271.8,353.6,281.44,360.54,286,362.38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.07,364.59a.45.45,0,0,1-.35-.74,10.92,10.92,0,0,1,8.43-3.33.46.46,0,0,1-.1.91,10.15,10.15,0,0,0-7.63,3A.46.46,0,0,1,287.07,364.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.05,362.12a.48.48,0,0,1-.29-.11.46.46,0,0,1-.06-.64,11,11,0,0,1,8.43-3.32.45.45,0,0,1,.41.5.45.45,0,0,1-.5.4,10.2,10.2,0,0,0-7.64,3A.44.44,0,0,1,283.05,362.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,359.78a.43.43,0,0,1-.28-.11.45.45,0,0,1-.07-.64,10.94,10.94,0,0,1,8.44-3.32.45.45,0,0,1-.1.9,10.14,10.14,0,0,0-7.63,3A.46.46,0,0,1,279,359.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.31,357.1a.46.46,0,0,1-.29-.1.46.46,0,0,1-.06-.64,11,11,0,0,1,8.43-3.33.46.46,0,1,1-.09.91,10.14,10.14,0,0,0-7.64,3A.43.43,0,0,1,275.31,357.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.66,354.43a.46.46,0,0,1-.28-.1.45.45,0,0,1-.07-.64c1.78-2.26,5.82-3.74,9.21-3.37a.45.45,0,1,1-.1.9c-3.05-.33-6.81,1-8.4,3A.46.46,0,0,1,271.66,354.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.21,379.29c.19,4.4-.2,7.37-1.49,10.1s-4.15,3.82-7.19,3.37-7.05-2.08-8.28-5.77-1.32-6.3-1.05-10.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.22,348.77c-1.22.22-1,6.14-1.1,12.09-.12,6.39-1.74,9.19-1.9,14.43-.17,6,.4,8.59,2.83,12s10.11,6.13,13.21.65c2.53-4.47,2.18-9.11,1.32-15-.89-6.07-1.56-10.34-1.78-15-.21-4.45-.33-8.77-1.44-9.16,0,.66,0,1.49,0,2.14,0,.5.1,2.91-.58,3a9.28,9.28,0,0,1-.18-1.67,2,2,0,0,0-.48-1.39,2.33,2.33,0,0,0-1.42-.47,35.09,35.09,0,0,0-3.69-.2c-.62,0-1.23,0-1.84.11a5,5,0,0,0-1.53.38,1.06,1.06,0,0,0-.6.66,1.94,1.94,0,0,0,0,.68,5.05,5.05,0,0,1,0,1.23c0,.18-.12.41-.3.38s-.22-.19-.24-.34c-.07-.71,0-1.24-.09-2.07,0-.38,0-.91,0-1.3S218.23,349.15,218.22,348.77Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.22,348.77c-1.22.22-1,6.14-1.1,12.09-.12,6.39-1.74,9.19-1.9,14.43-.17,6,.4,8.59,2.83,12s10.11,6.13,13.21.65c2.53-4.47,2.18-9.11,1.32-15-.89-6.07-1.56-10.34-1.78-15-.21-4.45-.33-8.77-1.44-9.16,0,.66,0,1.49,0,2.14,0,.5.1,2.91-.58,3a9.28,9.28,0,0,1-.18-1.67,2,2,0,0,0-.48-1.39,2.33,2.33,0,0,0-1.42-.47,35.09,35.09,0,0,0-3.69-.2c-.62,0-1.23,0-1.84.11a5,5,0,0,0-1.53.38,1.06,1.06,0,0,0-.6.66,1.94,1.94,0,0,0,0,.68,5.05,5.05,0,0,1,0,1.23c0,.18-.12.41-.3.38s-.22-.19-.24-.34c-.07-.71,0-1.24-.09-2.07,0-.38,0-.91,0-1.3S218.23,349.15,218.22,348.77Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.33,373.58c0,.86-.19,6.58,1.45,7.44s2.24-3.59,2.24-3.59,3.79-1.59,9.72.32c-.2.95,1,3.88,2.47,3.09s1.44-7.33,1.44-7.41c.81,5.63,1.06,10.13-1.39,14.47-3.1,5.48-10.78,2.71-13.21-.65s-3-6-2.83-12C215.24,374.69,215.28,374.12,215.33,373.58Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.33,373.58c0,.86-.19,6.58,1.45,7.44s2.24-3.59,2.24-3.59,3.79-1.59,9.72.32c-.2.95,1,3.88,2.47,3.09s1.44-7.33,1.44-7.41c.81,5.63,1.06,10.13-1.39,14.47-3.1,5.48-10.78,2.71-13.21-.65s-3-6-2.83-12C215.24,374.69,215.28,374.12,215.33,373.58Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.51,377.76c.19,2.14-2,1.63-2.39-1.38s.54-10.33,0-15.52c.11-5.95-.12-11.87,1.1-12.09,0,.08,0,.15,0,.22l.14,3c0,.44,0,.82.06,1.28.41,4.37.64,12.85.67,16.87A69.11,69.11,0,0,0,219.51,377.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.07,377.76a69.11,69.11,0,0,0,.41-7.61c0-4,.26-12.38.66-16.76a11.28,11.28,0,0,0,.18-2.48c0-.6,0-1.36,0-2a.57.57,0,0,0,0-.13c.81.29,1.09,2.65,1.27,5.62q0,2.58-.17,6.46c-.54,5.19.4,12.56,0,15.56S227.88,379.9,228.07,377.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.87,377.91l-.17,0a14.5,14.5,0,0,0-9.51,0,.46.46,0,1,1-.33-.85A15.12,15.12,0,0,1,229,377a.45.45,0,0,1,.26.59A.47.47,0,0,1,228.87,377.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.43,373.18a.45.45,0,0,1-.16,0,17.88,17.88,0,0,0-10.65,0,.46.46,0,1,1-.3-.86,18.6,18.6,0,0,1,11.26,0,.46.46,0,0,1,.28.58A.47.47,0,0,1,229.43,373.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.47,368.69a.46.46,0,0,1-.19-.87c5.3-2.41,11-.17,11.23-.07a.45.45,0,0,1,.26.59.47.47,0,0,1-.6.25s-5.58-2.19-10.51.06A.65.65,0,0,1,218.47,368.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.37,364.5a.44.44,0,0,1-.41-.26.45.45,0,0,1,.21-.61,14.13,14.13,0,0,1,11.45-.12.46.46,0,0,1,.22.61.46.46,0,0,1-.61.21,13.45,13.45,0,0,0-10.67.13A.43.43,0,0,1,218.37,364.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.27,359.8a.46.46,0,0,1-.41-.26.46.46,0,0,1,.21-.61c5.44-2.68,11.3-.12,11.54,0a.45.45,0,1,1-.37.83c-.06,0-5.72-2.5-10.77,0A.46.46,0,0,1,218.27,359.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.73,166.89a84.17,84.17,0,0,0-6.46,24.22c-2.34,30.38-1.08,74-1.08,74-.27,3.18-2.28,10.39-3.63,24.36-1.6,16.51.41,72.46.41,72.46s9.87,5.89,17.56-.81c0,0,8.93-76.91,11-93.33,1.81-14.32,6.86-45.32,6.86-45.32l5.91,45.84s-.55,12.89-.16,21.22c.44,9.69,3.15,59.06,3.15,59.06s13.57,4.59,19.63-1.93c0,0,1.44-68.48,1.65-80.14.4-22.87,0-64.55-3.71-88.54Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.73,166.89a84.17,84.17,0,0,0-6.46,24.22c-2.34,30.38-1.08,74-1.08,74-.27,3.18-2.28,10.39-3.63,24.36-1.6,16.51.41,72.46.41,72.46s9.87,5.89,17.56-.81c0,0,8.93-76.91,11-93.33,1.81-14.32,6.86-45.32,6.86-45.32l5.91,45.84s-.55,12.89-.16,21.22c.44,9.69,3.15,59.06,3.15,59.06s13.57,4.59,19.63-1.93c0,0,1.44-68.48,1.65-80.14.4-22.87,0-64.55-3.71-88.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.39,222.46l2.12-14.58s12.32-1.65,17.9-6.89a20.21,20.21,0,0,1-14.52,9.17l-2.17,13.19,1.87,39.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.93,144.94c-.54,6-.67,17.71-.67,17.71,2.17,15.32,3.91,30.28,3.91,30.28-22.88,12.21-57.41,2.33-61.76-2.71,2.15-15,6.89-24.34,10-32.78l-5.73-25.53s9.87-8.21,9-24.86l13.52-1.41,12.9.37,9.17.65a77.39,77.39,0,0,1,12,14.94C282.66,128.78,282.83,137.71,275.93,144.94Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.4,144s-6,5.28-13.3,3.19a12.3,12.3,0,0,1-8.78-8.28s-.24,8.24,9,10.46A11.86,11.86,0,0,0,260.4,144Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.35,97.54c0-2.29-3.22-7.06-6.16-12.41s-6.11-13.95,0-22,19.93-12.87,28.07-9,10.41,13.12,10.41,13.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.6,78.49a.13.13,0,0,0,0-.06,2.27,2.27,0,0,0-1.3-1,5,5,0,0,0-1.91-.31c-.77,0-2.24.55-2.19,1.55.05,1.18,2,1.31,2.84,1.27a8,8,0,0,0,2.15-.33,13.87,13.87,0,0,1-.59,4.12,4.09,4.09,0,0,1-1.14,1.58,2.81,2.81,0,0,1-2.41.51c-.47-.08-.27.59,0,.69a3.49,3.49,0,0,0,4.06-1.81c1-1.77.63-3.82,1.06-5.74C233.27,78.68,232.9,78.45,232.6,78.49Zm-3.81.62c-.15,0-.54-.1-.63-.25s.05-.21.14-.31a2.66,2.66,0,0,1,2.57-.4,4.18,4.18,0,0,1,.71.22,3,3,0,0,1,.36.19l.15.08.09,0a4.62,4.62,0,0,1-2,.47A5,5,0,0,1,228.79,79.11Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.16,60.07c3,1.56,7.32,4.89,6.66,20.44-.52,12.15-5,17.75-7,18.81s-4.64,1.32-8.7.89v6.91s4.68,12.42,1.84,18.73a56.51,56.51,0,0,1-10.48-7.31c-6.88-6.61-8.94-9.71-8.94-9.71l-.25-18.39s-2.7,2-6.92-1.28c-3.49-2.7-4.9-7.51-2.48-10.28A5.51,5.51,0,0,1,237,77.17a6.77,6.77,0,0,1,4.67,3.74c.19.37.48.76.89.8a1,1,0,0,0,.82-.37,2.31,2.31,0,0,0,.41-.83c.87-2.58.46-5.28,1.07-7.91A15,15,0,0,1,247.48,67a18.88,18.88,0,0,1,12.09-7.07A25.29,25.29,0,0,1,268.16,60.07Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.78,67.54h0a20.72,20.72,0,0,0-13.62-2.9,37.84,37.84,0,0,0-14.54,5.58A16.6,16.6,0,0,1,247.47,67a18.93,18.93,0,0,1,12.11-7.07,25.17,25.17,0,0,1,8.57.13C270.05,61,272.43,62.69,273.78,67.54Z",
    style: {
      fill: "#b16668"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.17,77A1.8,1.8,0,0,1,254.6,79a1.68,1.68,0,0,1-1.91-1.51,1.8,1.8,0,0,1,1.58-1.93A1.68,1.68,0,0,1,256.17,77Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.68,88.64l6.12,1.55A3.1,3.1,0,0,1,259,92.58,3.31,3.31,0,0,1,256.68,88.64Z",
    style: {
      fill: "#9a4a4d"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M271.89,72.92l-3.55-1.76a1.9,1.9,0,0,1,2.59-.94A2.09,2.09,0,0,1,271.89,72.92Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M254.66,71.57l-3.58,1.68a1.9,1.9,0,0,1,.88-2.61A2.07,2.07,0,0,1,254.66,71.57Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M270.31,76.19a1.79,1.79,0,0,1-1.57,1.93,1.68,1.68,0,0,1-1.9-1.5,1.79,1.79,0,0,1,1.57-1.94A1.68,1.68,0,0,1,270.31,76.19Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "261.4 75.84 262.27 85.79 267.42 83.84 261.4 75.84",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.08,100.21c-4.28-.63-13.35-2.92-14.92-6.28a10,10,0,0,0,3.48,4.81c2.74,2.07,11.44,3.92,11.44,3.92Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.78,67.54S271.56,64,261.4,64.93a38.49,38.49,0,0,0-15.78,5.3,22.48,22.48,0,0,0-7.39,7.32,5.67,5.67,0,0,0-1.25-.38,5.53,5.53,0,0,0-5.14,1.71l-.05.06c-1.85-3.39-3.22-6.83-2.45-11.85,1.08-7.07,8.09-12,15.88-15.26,9.21-3.92,19.31-2.92,23.35.9S273.67,67.18,273.78,67.54Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.83,194.72a35.22,35.22,0,0,1-7.48-6.66,23.25,23.25,0,0,0,5.45,0c2.48-.52,3-1.56,2.84-2.46-.09-.7-1.81-.48-4.54-1.33a48.82,48.82,0,0,0-9.56-2.26,6.63,6.63,0,0,1-3.91-2.65c-.86-1.07-5.94-10-10.42-19.48l20.71-25.62c5.17-5.79,11.35-16.18,5.15-26.82-14.23,3-14.12,2.65-42.58,44.78-4.91,7.27-4.51,10.69,13,32.37a138.14,138.14,0,0,0,11.37,12.5c10.11,9.43,17.42,10.11,21.62,7.56C238.23,201.12,236.36,198.36,230.83,194.72Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.64,107.05c-7.79.35-13.53,1.46-19,8.15-5.87,7.15-19.46,26.79-19.46,26.79s3.64,11.23,18.28,15l18.44-23.67S235.63,120.11,230.64,107.05Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.64,107.05c-7.79.35-13.53,1.46-19,8.15-5.87,7.15-19.46,26.79-19.46,26.79s3.64,11.23,18.28,15l18.44-23.67S235.63,120.11,230.64,107.05Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.32,115.7c-7,.19-9,3-13.18,9s-18.55,28.82-18.55,28.82l-20.31,7.8L67,173.18s17.18-3.42,26-5.22a7.51,7.51,0,0,0,5.52-3.76c1.13-1.71,12.42-19.47,12.42-19.47Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.68,115.89c-6.61-1.65-9.53,2-11.73,6.08-3.52,6.46-5.64,19.66-5.94,43.78-.19,15.51-5.59,34.26-6.55,49C96,236.83,95.32,254,95.32,254a282.8,282.8,0,0,1,39.44-2.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.78,340.82s4-27.15,2.31-43.06c-1.42-13.65-3.43-19.36-3.71-22.47,0,0-2.3-32-1.67-59.19.29-12.87-.36-27.06-9.52-42.23l-.33-.6c-.81,5-8.48,8.2-15.32,9q-9.88,1.1-24.6-3.91c-2.19,12.87-4.67,37.4-7.21,64.13-1.23,13.07-1,24.07-1.24,32.47-.29,11.4.75,56.06.75,56.06l0,1.89c-.07,2.08-.57,3.53-2,6.83a40.34,40.34,0,0,1-7.52,11.56c-1,1-7.73,6.51-8.64,7.71-2.93,3.2,2.85,5.24,7.21,4.81,4.6-.46,11.76-2,13.87-4.69,1.41-1.81,2.63-8.28,4.07-10.12,4.87-6.19,6.87-8.86,7-10.88.18-3.67-1-5.16-1.41-7.24.51-4.31,9.27-26.87,9.85-39.46.28-6-1-16.64-1-16.64L128.24,231c1.71,12.3,5,40,6.13,48.85C136,292,142,312.55,145.78,328.69c1.42,6.07,2.12,8.77,2.47,12.73l.09,1.42c0,1.79.18,20.92.76,25,1.2,8.47,8.71,7.66,10.14.89,1.21-5.76.53-23.73.57-25.94Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,340.7c2.11.11.45,8.23.82,13.51.4,5.65,2.11,9.83,2.48,14.46.43,5.3-.11,7.5-2.15,11.77-1.58,3.33-9.13,7.71-11.78,2.79s-3.07-10.45-2.57-15.7c.51-5.42,1-9.38,1.22-13.51.21-3.64-2.31-12.28.45-12.71l.08,1.42c.92,2,10.24,3.66,11.48-.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.7,342.43c.56,2.65-.35,9.85-.35,9.85s-1.22,2.45-5.34,4l-1.49-10.1Z",
    style: {
      fill: "#263238"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "108.01 356.25 99.15 353.01 97.26 344.99 107.15 350.42 108.01 356.25"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.47,332.76v-1.89c-1.23.55-4.23,10.26-8.08,16.86-3.5,6-10.17,9.22-12.38,11.82-3,3.48,2.41,8.27,11.35,6.66,4.43-.79,11.2-3.39,13.1-6.3s2.7-8.35,4.25-10.49,5.15-4.53,6-7a13.67,13.67,0,0,0,.21-6.87c-.62-2.29-1.14-5-1.92-4.82l-.11,1.72c-.63,1.19-2.82,2.53-7.31,2.62C102.43,335.12,100.38,334.73,99.47,332.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.77,296.22a92.89,92.89,0,0,0-.75-20.64l6.46-43s4.4,41,5.14,47.32,12.54,74.84,12.54,74.84c6,3.58,13.79,2.44,18.83-.23,0-27.7-.86-55.46-1.86-63.13a132,132,0,0,0-3.59-15.52s-.64-40.41-.61-55.75-1.12-25.6-4-32.5a98.39,98.39,0,0,0-8-14.39s-2.24,7.57-20,7.59-19.72-4.49-19.72-4.49-5.2,18.17-6.93,45.61c-1.4,22.11-1.72,32.17-2.14,42-.36,8.4-.58,18.1-.77,35.07-.15,12.8-2,41-2,41s8.67,4.54,23-.64C118.31,339.32,121.88,307.26,122.77,296.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.48,232.54l-3.51-26A22.26,22.26,0,0,1,111.38,200s2,6.3,10.32,9.84l4.71,22.83L123,269.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.79,117.7l8.36.89c5.56,1.36,8.06,3.81,8.63,8.73a38.47,38.47,0,0,1-.29,16c-1.76,6.92-6.44,23.87-6.44,23.87s6.07,15.25,8.94,23c-19.73,12.87-44.09,7.79-52.27,0,.69-7.37,3.3-14.22,3.88-20.79,0,0-.43-10.26-1.24-14.71-6.24-6.81-5.45-13.33-2.64-18.59,5.17-9.7,13-18.23,15.5-18.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.79,117.7l8.36.89c5.56,1.36,8.06,3.81,8.63,8.73a38.47,38.47,0,0,1-.29,16c-1.76,6.92-6.44,23.87-6.44,23.87s6.07,15.25,8.94,23c-19.73,12.87-44.09,7.79-52.27,0,.69-7.37,3.3-14.22,3.88-20.79,0,0-.43-10.26-1.24-14.71-6.24-6.81-5.45-13.33-2.64-18.59,5.17-9.7,13-18.23,15.5-18.22Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.59,111.82c-2.48,0-2.76.42-4.9,3.27-1.27,1.7-9.29,14.93-9.29,14.93s6.39-8.39,11.2-10.93a10.65,10.65,0,0,1,3-1.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.26,117.7s-6.89,18.12-8.46,30.42,3.82,49.45,4.65,71.47c.61,16,2.13,39.12,2.13,39.12a57.1,57.1,0,0,0,14.67-.46c8.1-1.53,10.61-2.86,15.24-5.88,0,0-4-40.27-6-55.92-1.85-14.73-9.77-29.26-9.77-29.26l9.52-39.41s-.47-6.64-6.73-8.5C146.58,117.51,137.26,117.7,137.26,117.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.45,154.53s-1.29-4.69-3.07-12.7-1.5-12.65-.89-16.15l10.35,15.14-6.1,26.36h0a100.14,100.14,0,0,1,9.11,25.17h0c-6.23-17.63-13.06-22.92-13.06-22.92Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.86,140c0-.76.07-2.41.2-4.48.65-10.16.95-19.33-2.48-20.07l-.3,1.4c2.5.54,1.67,13.64,1.36,18.58-.14,2.12-.25,3.79-.21,4.63Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.67,222.29c1.33-2.53,1.31-4.35,3.38-6.64a7.29,7.29,0,0,0,1.8-3.36,23.85,23.85,0,0,0,.49-6.19l11.86.18c.09,3.94.62,9.6-.12,13.8-1.89,10.63-4,15.16-8.46,16.4-7.13,2-9.05-1-6.77-6.38a26,26,0,0,0,2-7,13.27,13.27,0,0,1-2.58,2.53,2.54,2.54,0,0,1-3.44-.21C156.48,225,157.64,224.26,158.67,222.29Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.11,118.22s7.66-.48,12.15,3.19,7.27,13.93,10.56,24.19,6.24,20.24,7.32,27.43c.91,6-.27,37.83-.27,37.83a26.23,26.23,0,0,1-13.71-2.42L160,174.5l-12.84-34.85A33.26,33.26,0,0,1,147.11,118.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.97 142.76 89.97 156.17 100.43 201.39 99.58 202.29 63.45 188.8 51.12 143.66 51.97 142.76",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.12 157.07 99.58 202.29 100.43 201.39 89.97 156.17 89.12 157.07",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.12 143.66 89.12 157.07 99.58 202.29 63.45 188.8 51.12 143.66",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1,179.61c-.35.88-3.26,2.84-7.48,2.49l-.71-2.61Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.56,152.93l-.31-1.52c-.17-.84,2.06-.4,5,1l6.86,2.08c2.93,1.38,5.69,2.41,5.86,3.24l.32,1.52Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M60.31,146.07c-.11-.53.75-.42,2-.1l2.19.75s-.9-2.2,4.28-.8c5.7,1.55,5.82,4.39,5.82,4.39a24.87,24.87,0,0,0,2.74,1c1.89.62,2.1,1,2.26,1.52l.28,1L60.48,147S60.42,146.59,60.31,146.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.34,149c1.8.81,2.54,1.21,2.81,2.5.3,1.47.37,2.09.37,2.09l10.09,4s-.55-2.17-.68-2.9,1.2-.73,2.94.08l-.41-1.81-15.69-5.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,153l-.31-1.51c-.17-.84,2.06-.4,5,1l6.86,2.07c2.92,1.38,5.69,2.41,5.86,3.25l.31,1.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.34,159.13s1.35,5,1.7,6.22,6.58,4.12,9.7,4.51c6,.75,6.63,2,5.2,6.27-1.32,3.9-5.2,5.37-10.58,4.74A9.76,9.76,0,0,1,54,174.43c-1.75-5-.81-10.31-1.5-13.23S53.83,157.4,55.34,159.13Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.32,73.33,146,77.7a3.24,3.24,0,0,1,.45-4.69A3.55,3.55,0,0,1,151.32,73.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.36,112.48c0-3.35,7.81-8.37,11.84-15.43s2-18.63-3.5-20.41c0,0-.11-10.54-14.33-13.34s-18.68-5.94-21.2-6.39-3,8.51.31,10.86a19.59,19.59,0,0,1-6.4-4.1c-2.07-2-2.89,8.42,1.58,12.08,0,0-3.7,2.17-3.25,7.65a9.15,9.15,0,0,0,7.07,8.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.11,73c-3.43,1.49-6.69,6.73-6.64,21.4,0,12.43,3.85,15.58,5.78,16.5s5.68.46,9.34-.11l0,7.15s-2.73,2.69-1.78,4.39,4.52,3.12,10,1.39c6.25-2,7.68-6.13,7.68-6.13l.12-15.64s2.11,2.21,5.8-1c3.06-2.67,4.16-7.26,1.86-9.78s-5.24-2.72-7.89.1l-1.92-1c-3.39-.4-8.42-1-12.06-2.82C114,82.58,113,77.36,113.11,73Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.36,89.17l0,6.91A3.25,3.25,0,0,1,134,92.73,3.57,3.57,0,0,1,137.36,89.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.78,90.14a1.67,1.67,0,0,1-1.59,1.76,1.71,1.71,0,1,1,1.59-1.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.94,90.87a1.79,1.79,0,0,1-1.7,1.9,1.84,1.84,0,1,1,1.7-1.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.25,101.05l-5.32,1.66a2.71,2.71,0,0,0,3.4,2A3.06,3.06,0,0,0,123.25,101.05Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.41,87.07l4.26-1.69a2.21,2.21,0,0,0-3-1.31A2.39,2.39,0,0,0,108.41,87.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.81 88.79 117.02 98.98 111.55 97.76 116.81 88.79",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.59,110.75c3.85-.45,11.79-2.66,13.08-5.88a8.49,8.49,0,0,1-2.84,4.09c-2.4,2.06-10.25,4.2-10.25,4.2Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.54,111.87c1-.2,1.91.23,2.73,1.63s2.63,4.34,2.63,4.34.93,9.76,0,12.18c-.81,2.11-9.73,10-9.73,10s2.33,8.77,2.41,11.64-5.53,13.8-6.16,19.39c0,0-1.76-17.57-.94-23.88,1.44-11,6.59-25.13,9-29.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.77,172.25a7.74,7.74,0,0,1-4.38,1.28l.13-1a6.23,6.23,0,0,0,3.37-.94,12.27,12.27,0,0,1-2.51-2.69c-1.43-2.22-3.68-17.37-2.3-20.74,1.14-2.8,4.49-8.87,7-8.87h.06c2.55.11,5.41,6.53,6.32,9.44,1.09,3.47-2.44,18.38-4.05,20.47a12.71,12.71,0,0,1-2.73,2.47,6.36,6.36,0,0,0,3.28,1.22l0,1h-.12A8,8,0,0,1,137.77,172.25ZM133,148.54c-1.26,3.1.9,17.76,2.22,19.81a11.93,11.93,0,0,0,2.6,2.7,11.56,11.56,0,0,0,2.82-2.47c1.5-1.93,4.9-16.36,3.9-19.55-1.23-3.9-3.91-8.67-5.41-8.73h0C137.59,140.29,134.55,144.78,133,148.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,173a1.47,1.47,0,0,0,1.41,1.53,1.49,1.49,0,0,0,1.54-1.41,1.48,1.48,0,0,0-3-.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.54,173.33a1.47,1.47,0,0,0,2.94.13,1.47,1.47,0,1,0-2.94-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.83,154.73l.84-.06a.33.33,0,0,0,.31-.35,16.62,16.62,0,0,1,.26-5.68c1.48-3.62,4.54-8.15,5.88-8.09s4,4.83,5.18,8.56c.27.85.18,2.91-.22,5.68a.33.33,0,0,0,.27.38l.84.13a.33.33,0,0,0,.37-.29c.46-3.11.52-5.25.17-6.35-.62-2-3.57-9.49-6.54-9.62s-6.55,7.09-7.34,9c-.44,1.07-.57,3.2-.37,6.34A.33.33,0,0,0,131.83,154.73Z",
    style: {
      fill: "#BA68C8"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--red-cross--inject-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "44.35 86.61 44.35 99.03 55.11 92.82 55.11 105.25 65.87 99.03 65.87 86.61 76.63 80.4 76.63 67.97 65.84 74.21 65.87 61.76 55.11 67.97 55.11 80.4 44.35 86.61",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.35 99.03 39.74 96.37 39.74 83.95 44.35 86.61 44.35 99.03",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.11 80.4 50.5 77.74 39.74 83.95 44.35 86.61 55.11 80.4",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.11 67.97 50.5 65.31 50.5 77.74 55.11 80.4 55.11 67.97",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.87 61.76 61.26 59.1 50.5 65.31 55.11 67.97 65.87 61.76",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.11 105.25 50.5 102.58 50.5 95.48 55.11 92.82 55.11 105.25",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "44.35 99.03 39.74 96.37 39.74 83.95 44.35 86.61 44.35 99.03"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "55.11 67.97 50.5 65.31 50.5 77.74 55.11 80.4 55.11 67.97"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "55.11 105.25 50.5 102.58 50.5 95.48 55.11 92.82 55.11 105.25"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "76.63 67.97 72.02 65.31 65.85 68.85 65.84 74.21 76.63 67.97",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "55.11 80.4 50.5 77.74 39.74 83.95 44.35 86.61 55.11 80.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.87 61.76 61.26 59.1 50.5 65.31 55.11 67.97 65.87 61.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.63 67.97 72.02 65.31 65.85 68.85 65.84 74.21 76.63 67.97",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pill--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437,67.77c0,1.22.81,2.45,2.43,3.38a12.94,12.94,0,0,0,11.72,0c1.62-.93,2.43-2.16,2.43-3.38V56.87a8.3,8.3,0,1,0-16.6,0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,82.16a8.3,8.3,0,1,0,16.6,0V67.77c0,1.22-.81,2.45-2.43,3.38a12.94,12.94,0,0,1-11.72,0C437.82,70.22,437,69,437,67.77Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.47,86.63a3.17,3.17,0,0,1-3.18-3.17V66.57a11.93,11.93,0,0,1,5.87,1.4c.18.1.33.2.49.31V83.46A3.18,3.18,0,0,1,448.47,86.63Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,67.77c0,1.22.81,2.45,2.43,3.38a12.94,12.94,0,0,0,11.72,0c1.62-.93,2.43-2.16,2.43-3.38V56.87a8.3,8.3,0,1,0-16.6,0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.16,71.15a12.94,12.94,0,0,1-11.72,0C437.82,70.22,437,69,437,67.77V69c0,1.23.81,2.45,2.43,3.39a12.94,12.94,0,0,0,11.72,0c1.62-.94,2.43-2.16,2.43-3.39v-1.2C453.59,69,452.78,70.22,451.16,71.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.17,50.17h0A8.29,8.29,0,0,0,437,56.87l0,10.9c0,1.22.81,2.45,2.43,3.38a9.88,9.88,0,0,0,2.38,1V55.38C441.82,50.6,447.8,48.85,450.17,50.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.47,52.49a3.18,3.18,0,0,0-3.18,3.18V72.56a11.94,11.94,0,0,0,5.87-1.41c.18-.1.33-.2.49-.3V55.67A3.18,3.18,0,0,0,448.47,52.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.33,90.39l.47-.08.33-.06.37-.1.38-.11.18-.07a8,8,0,0,0,1.56-.74l0,0a4.52,4.52,0,0,0,.51-.34h0c-2.37,1.31-8.35-.43-8.35-5.21V72.11a9.88,9.88,0,0,1-2.38-1C437.82,70.22,437,69,437,67.77l0,14.39a8.31,8.31,0,0,0,8.3,8.3c.26,0,.52,0,.77,0Z",
    style: {
      opacity: 0.1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy);
export default __webpack_public_path__ + "static/media/why.3da714e584e3f0b6e69da0a7952fda57.svg";
export { ForwardRef as ReactComponent };